/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyConfigurationManagement {
    getFixupPrototypeFunction() { return PolicyConfigurationManagement.fixupPrototype; }

    static newInstance(model: Partial<PolicyConfigurationManagement>): PolicyConfigurationManagement {
        let obj = Object.assign(new PolicyConfigurationManagement(), model);
        PolicyConfigurationManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyConfigurationManagement>): PolicyConfigurationManagement {
        if (!model) return null;
        return PolicyConfigurationManagement.newInstance(<PolicyConfigurationManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyConfigurationManagement) {
        if (!obj) return;

        models.PolicyConfigurationManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyConfigurationManagement): boolean {
        Object.setPrototypeOf(obj, PolicyConfigurationManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Value identifier for the option
     */
    itsm_change_management: boolean;

}
